module.exports = __webpack_public_path__ + "img/mv01.f1b3738d.jpg";